import React, { Component } from "react";
import "./Cash.css";

class Cash extends Component {
	reformatValue(e) {
		let val = e.target.value.replace("M", "");
		val = val.replace("m", "").trim();
		this.props.buildSearchQuery("cash_needed_in_m", val);
	}
	render() {
		return (
			<section>
				<p className="panel-section-header">Cash Needed For This Deal</p>
				<div>
					<small>specify cash needed for this deal (in M USD).</small>
					<br />
					<input
						defaultValue={
							this.props.query["cash_needed_in_m"] === undefined
								? ""
								: this.props.query["cash_needed_in_m"]
						}
						onInput={e => this.reformatValue(e)}
						type="text"
						placeholder="e.g. 250"
					/>
				</div>
			</section>
		);
	}
}

export default Cash;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquirorsOptions/Cash/Cash.js